import React, { useState, useEffect } from 'react';
import { Users as UsersIcon, ArrowDownCircle, ArrowUpCircle, Settings, Menu, X, LogOut } from 'lucide-react';
import './AdminPanel.css';
import Users from './Users'; 
import AdminDeposit from './AdminDeposit'; 
import AdminWithdrawal from './AdminWithdrawal';
import AdminSettings from './AdminSettings'; 
import AdminLogin from './AdminLogin'; 

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check if session is active
  useEffect(() => {
    const auth = sessionStorage.getItem('adminAuth');
    if (auth === 'true') {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('adminAuth');
    setIsLoggedIn(false);
  };

  if (!isLoggedIn) {
    return <AdminLogin onLoginSuccess={() => setIsLoggedIn(true)} />;
  }

  const menuItems = [
    { id: 'users', label: 'Users', icon: <UsersIcon size={20} /> },
    { id: 'deposit', label: 'Deposit', icon: <ArrowDownCircle size={20} /> },
    { id: 'withdrawal', label: 'Withdrawal', icon: <ArrowUpCircle size={20} /> },
    { id: 'settings', label: 'Other Settings', icon: <Settings size={20} /> },
  ];

  return (
    <div className="admin-wrapper">
      <button className="mobile-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <aside className={`admin-sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="admin-logo">
          <h2>DR<span>Core</span></h2>
        </div>
        <nav className="admin-nav">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => setActiveTab(item.id)}
            >
              {item.icon}
              <span>{item.label}</span>
            </div>
          ))}
          
          {/* Logout Button */}
          <div className="nav-item logout-btn" onClick={handleLogout} style={{ marginTop: 'auto', color: '#ff4d4d' }}>
            <LogOut size={20} />
            <span>Logout</span>
          </div>
        </nav>
      </aside>

      <main className="admin-main-full">
        <div className="admin-view-container">
          {activeTab === 'users' && <Users />} 
          {activeTab === 'deposit' && <AdminDeposit />} 
          {activeTab === 'withdrawal' && <AdminWithdrawal />} 
          
          {/* Settings tab call */}
          {activeTab === 'settings' && <AdminSettings />} 
        </div>
      </main>
    </div>
  );
};

export default AdminPanel;